import { useEffect, useRef } from 'react';

export function useReveal(options = {}) {
	const ref = useRef(null);

	useEffect(() => {
		const element = ref.current;
		if (!element) return;

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add('state-visible');
						if (options.once) observer.unobserve(entry.target);
					} else if (!options.once) {
						entry.target.classList.remove('state-visible');
					}
				});
			},
			{
				rootMargin: options.rootMargin || '0px 0px -15% 0px',
				threshold: options.threshold ?? 0
			}
		);

		observer.observe(element);

		return () => observer.disconnect();
	}, [options.once, options.rootMargin, options.threshold, options.deps]);

	return ref;
}
